import * as THREE from 'three'
import Box from './Box'
import Position from './Position'
import Frame from './Frame'
import Size from './Size'

export default class ClampGenerator {
  public readonly color: number = 0x444444
  public create (frame: Frame, box: Box): THREE.Object3D[] {
    const scale = frame.scale
    const diff = 90
    const append = 0.05

    const clamps: THREE.Object3D[] = []
    const outer = box.outer
    const size = box.clampSize
    const nums = box.clampNums
    // 天板・側板
    if (box.face.top && box.face.side) {
      clamps.push(
        // 上右手前側面パーツ
        ...this.expandZ(
          new Size(box.thick.side, box.clampSize.y, box.clampSize.z),
          {
            x: (outer.x / 2 - box.thick.side / 2) * scale + append,
            y: (outer.y / 2 - size.y / 2) * scale + append,
            z: ((outer.z / 2 - size.z / 2 - diff) * scale + append) * -1
          },
          nums.z,
          scale
        ),
        // 上右手前天面パーツ
        ...this.expandZ(
          new Size(box.clampSize.x, box.thick.top, box.clampSize.z),
          {
            x: (outer.x / 2 - size.x / 2) * scale + append,
            y: (outer.y / 2 - box.thick.top / 2) * scale + append,
            z: ((outer.z / 2 - size.z / 2 - diff) * scale + append) * -1
          },
          nums.z,
          scale
        ),
        // 上左奥側面パーツ
        ...this.expandZ(
          new Size(box.thick.side, box.clampSize.y, box.clampSize.z),
          {
            x: ((outer.x / 2 - box.thick.side / 2) * scale + append) * -1,
            y: (outer.y / 2 - size.y / 2) * scale + append,
            z: ((outer.z / 2 - size.z / 2 - diff) * scale + append) * -1
          },
          nums.z,
          scale
        ),
        // 上左奥天面パーツ
        ...this.expandZ(
          new Size(box.clampSize.x, box.thick.top, box.clampSize.z),
          {
            x: ((outer.x / 2 - size.x / 2) * scale + append) * -1,
            y: (outer.y / 2 - box.thick.top / 2) * scale + append,
            z: ((outer.z / 2 - size.z / 2 - diff) * scale + append) * -1
          },
          nums.z,
          scale
        ),
        // 上手前側面パーツ
        ...this.expandX(
          new Size(box.clampSize.x, box.clampSize.y, box.thick.side),
          {
            x: ((outer.x / 2 - size.x / 2 - diff) * scale + append) * -1,
            y: (outer.y / 2 - size.y / 2) * scale + append,
            z: (outer.z / 2 - box.thick.side / 2) * scale + append
          },
          nums.x,
          scale
        ),
        // 上手前天面パーツ
        ...this.expandX(
          new Size(box.clampSize.x, box.thick.top, box.clampSize.z),
          {
            x: ((outer.x / 2 - size.x / 2 - diff) * scale + append) * -1,
            y: (outer.y / 2 - box.thick.top / 2) * scale + append,
            z: (outer.z / 2 - size.z / 2) * scale + append
          },
          nums.x,
          scale
        ),
        // 上奥側面パーツ
        ...this.expandX(
          new Size(box.clampSize.x, box.clampSize.y, box.thick.side),
          {
            x: ((outer.x / 2 - size.x / 2 - diff) * scale + append) * -1,
            y: (outer.y / 2 - size.y / 2) * scale + append,
            z: ((outer.z / 2 - box.thick.side / 2) * scale + append) * -1
          },
          nums.x,
          scale
        ),
        // 上奥天面パーツ
        ...this.expandX(
          new Size(box.clampSize.x, box.thick.top, box.clampSize.z),
          {
            x: ((outer.x / 2 - size.x / 2 - diff) * scale + append) * -1,
            y: (outer.y / 2 - box.thick.top / 2) * scale + append,
            z: ((outer.z / 2 - size.z / 2) * scale + append) * -1
          },
          nums.x,
          scale
        )
      )
    }
    // 底板・側板
    if (box.face.bottom && box.face.side) {
      clamps.push(
        // 下右手前側面パーツ
        ...this.expandZ(
          new Size(box.thick.side, box.clampSize.y, box.clampSize.z),
          {
            x: (outer.x / 2 - box.thick.side / 2) * scale + append,
            y: ((outer.y / 2 - size.y / 2) * scale + append) * -1,
            z: ((outer.z / 2 - size.z / 2 - diff) * scale + append) * -1
          },
          nums.z,
          scale
        ),
        // 下右手前底面パーツ
        ...this.expandZ(
          new Size(box.clampSize.x, box.thick.bottom, box.clampSize.z),
          {
            x: (outer.x / 2 - size.x / 2) * scale + append,
            y: ((outer.y / 2 - box.thick.bottom / 2) * scale + append) * -1,
            z: ((outer.z / 2 - size.z / 2 - diff) * scale + append) * -1
          },
          nums.z,
          scale
        ),
        // 下左奥側面パーツ
        ...this.expandZ(
          new Size(box.thick.side, box.clampSize.y, box.clampSize.z),
          {
            x: ((outer.x / 2 - box.thick.side / 2) * scale + append) * -1,
            y: ((outer.y / 2 - size.y / 2) * scale + append) * -1,
            z: ((outer.z / 2 - size.z / 2 - diff) * scale + append) * -1
          },
          nums.z,
          scale
        ),
        // 下左奥天面パーツ
        ...this.expandZ(
          new Size(box.clampSize.x, box.thick.bottom, box.clampSize.z),
          {
            x: ((outer.x / 2 - size.x / 2) * scale + append) * -1,
            y: ((outer.y / 2 - box.thick.bottom / 2) * scale + append) * -1,
            z: ((outer.z / 2 - size.z / 2 - diff) * scale + append) * -1
          },
          nums.z,
          scale
        ),
        // 下手前側面パーツ
        ...this.expandX(
          new Size(box.clampSize.x, box.clampSize.y, box.thick.side),
          {
            x: ((outer.x / 2 - size.x / 2 - diff) * scale + append) * -1,
            y: ((outer.y / 2 - size.y / 2) * scale + append) * -1,
            z: (outer.z / 2 - box.thick.side / 2) * scale + append
          },
          nums.x,
          scale
        ),
        // 下手前底面パーツ
        ...this.expandX(
          new Size(box.clampSize.x, box.thick.bottom, box.clampSize.z),
          {
            x: ((outer.x / 2 - size.x / 2 - diff) * scale + append) * -1,
            y: ((outer.y / 2 - box.thick.bottom / 2) * scale + append) * -1,
            z: (outer.z / 2 - size.z / 2) * scale + append
          },
          nums.x,
          scale
        ),
        // 下奥側面パーツ
        ...this.expandX(
          new Size(box.clampSize.x, box.clampSize.y, box.thick.side),
          {
            x: ((outer.x / 2 - size.x / 2 - diff) * scale + append) * -1,
            y: ((outer.y / 2 - size.y / 2) * scale + append) * -1,
            z: ((outer.z / 2 - box.thick.side / 2) * scale + append) * -1
          },
          nums.x,
          scale
        ),
        // 下奥底面パーツ
        ...this.expandX(
          new Size(box.clampSize.x, box.thick.bottom, box.clampSize.z),
          {
            x: ((outer.x / 2 - size.x / 2 - diff) * scale + append) * -1,
            y: ((outer.y / 2 - box.thick.bottom / 2) * scale + append) * -1,
            z: ((outer.z / 2 - size.z / 2) * scale + append) * -1
          },
          nums.x,
          scale
        )
      )
    }
    // 側板・側板
    if (box.face.side) {
      clamps.push(
        // 側面右前・前パーツ
        ...this.expandY(
          new Size(box.clampSize.x, box.clampSize.y, box.thick.side),
          {
            x: (outer.x / 2 - size.x / 2) * scale + append,
            y: (outer.y / 2 - size.y / 2 - diff) * scale,
            z: (outer.z / 2 - box.thick.side / 2) * scale + append
          },
          nums.y,
          scale
        ),
        // 側面右前・右パーツ
        ...this.expandY(
          new Size(box.thick.side, box.clampSize.y, box.clampSize.z),
          {
            x: (outer.x / 2 - box.thick.side / 2) * scale + append,
            y: (outer.y / 2 - size.y / 2 - diff) * scale,
            z: (outer.z / 2 - size.z / 2) * scale + append
          },
          nums.y,
          scale
        ),
        // 側面左前・前パーツ
        ...this.expandY(
          new Size(box.clampSize.x, box.clampSize.y, box.thick.side),
          {
            x: ((outer.x / 2 - size.x / 2) * scale + append) * -1,
            y: (outer.y / 2 - size.y / 2 - diff) * scale,
            z: (outer.z / 2 - box.thick.side / 2) * scale + append
          },
          nums.y,
          scale
        ),
        // 側面左前・左パーツ
        ...this.expandY(
          new Size(box.thick.side, box.clampSize.y, box.clampSize.z),
          {
            x: ((outer.x / 2 - box.thick.side / 2) * scale + append) * -1,
            y: (outer.y / 2 - size.y / 2 - diff) * scale,
            z: (outer.z / 2 - size.z / 2) * scale + append
          },
          nums.y,
          scale
        ),
        // 側面右奥・後パーツ
        ...this.expandY(
          new Size(box.clampSize.x, box.clampSize.y, box.thick.side),
          {
            x: (outer.x / 2 - size.x / 2) * scale + append,
            y: (outer.y / 2 - size.y / 2 - diff) * scale,
            z: ((outer.z / 2 - box.thick.side / 2) * scale + append) * -1
          },
          nums.y,
          scale
        ),
        // 側面右奥・右パーツ
        ...this.expandY(
          new Size(box.thick.side, box.clampSize.y, box.clampSize.z),
          {
            x: (outer.x / 2 - box.thick.side / 2) * scale + append,
            y: (outer.y / 2 - size.y / 2 - diff) * scale,
            z: ((outer.z / 2 - size.z / 2) * scale + append) * -1
          },
          nums.y,
          scale
        ),
        // 側面左奥・後パーツ
        ...this.expandY(
          new Size(box.clampSize.x, box.clampSize.y, box.thick.side),
          {
            x: ((outer.x / 2 - size.x / 2) * scale + append) * -1,
            y: (outer.y / 2 - size.y / 2 - diff) * scale,
            z: ((outer.z / 2 - box.thick.side / 2) * scale + append) * -1
          },
          nums.y,
          scale
        ),
        // 側面左奥・左パーツ
        ...this.expandY(
          new Size(box.thick.side, box.clampSize.y, box.clampSize.z),
          {
            x: ((outer.x / 2 - box.thick.side / 2) * scale + append) * -1,
            y: (outer.y / 2 - size.y / 2 - diff) * scale,
            z: ((outer.z / 2 - size.z / 2) * scale + append) * -1
          },
          nums.y,
          scale
        )
      )
    }
    return clamps
  }

  private expandX (size: Size, base: Position, num: number, scale: number): THREE.Object3D[] {
    const clamps: THREE.Object3D[] = []
    const x1 = base.x
    const x2 = base.x * -1
    for (let i = 0; i < num; i++) {
      const p = num > 1 ? x1 + ((x2 - x1) / (num - 1)) * i : base.x / 2
      const pos = new Position(p, base.y, base.z)
      clamps.push(this.getClampObject(size, pos, scale))
    }
    return clamps
  }
  private expandY (size: Size, base: Position, num: number, scale: number): THREE.Object3D[] {
    const clamps: THREE.Object3D[] = []
    const y1 = base.y
    const y2 = base.y * -1
    for (let i = 0; i < num; i++) {
      const p = num > 1 ? y1 + ((y2 - y1) / (num - 1)) * i : base.y / 2
      const pos = new Position(base.x, p, base.z)
      clamps.push(this.getClampObject(size, pos, scale))
    }
    return clamps
  }
  private expandZ (size: Size, base: Position, num: number, scale: number): THREE.Object3D[] {
    const clamps: THREE.Object3D[] = []
    const z1 = base.z
    const z2 = base.z * -1
    for (let i = 0; i < num; i++) {
      const p = num > 1 ? z1 + ((z2 - z1) / (num - 1)) * i : base.z / 2
      const pos = new Position(base.x, base.y, p)
      clamps.push(this.getClampObject(size, pos, scale))
    }
    return clamps
  }

  private getClampObject (size: Size, position: Position, scale: number): THREE.Object3D {
    const clamp = new THREE.Mesh(
      new THREE.CubeGeometry(size.x * scale, size.y * scale, size.z * scale),
      new THREE.MeshPhongMaterial({ color: this.color })
    )
    clamp.position.x = position.x
    clamp.position.y = position.y
    clamp.position.z = position.z
    return clamp
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/ClampGenerator.ts